import React from 'react';
import { Filter, X } from 'lucide-react';

interface ConsumerFilterBarProps {
  activeFilterCount: number;
  draftFilterCount: number;
  onApply: () => void;
  onClear: () => void;
  children: React.ReactNode;
}

const ConsumerFilterBar: React.FC<ConsumerFilterBarProps> = ({
  activeFilterCount,
  draftFilterCount,
  onApply,
  onClear,
  children,
}) => (
  <div className="rounded-2xl border border-line bg-card shadow-sm overflow-hidden">
    <div className="px-5 py-4 sm:px-6 flex flex-col xl:flex-row xl:items-end gap-3">
      <div className="flex items-center gap-2 shrink-0 xl:pb-2">
        <Filter size={16} className="text-muted" />
        <span className="text-sm font-bold text-heading">Filters</span>
        {activeFilterCount > 0 && (
          <span className="px-2 py-0.5 rounded-full bg-indigo-500/15 text-indigo-700 text-[10px] font-bold">
            {activeFilterCount} active
          </span>
        )}
      </div>

      <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 min-w-0">{children}</div>

      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          onClick={onClear}
          disabled={activeFilterCount === 0 && draftFilterCount === 0}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg border border-line text-sm font-semibold text-muted hover:text-heading hover:bg-subtle transition-colors disabled:opacity-50"
        >
          <X size={14} />
          Clear
        </button>
        <button
          type="button"
          onClick={onApply}
          className="px-5 py-2 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:opacity-95 transition-opacity"
        >
          Apply Filters
        </button>
      </div>
    </div>
  </div>
);

export default ConsumerFilterBar;

export const ConsumerFilterField: React.FC<{
  label: string;
  children: React.ReactNode;
  className?: string;
}> = ({ label, children, className = '' }) => (
  <div className={className}>
    <label className="block text-[10px] font-bold text-muted uppercase tracking-wider mb-1.5">{label}</label>
    {children}
  </div>
);

export const consumerFilterInputClass =
  'w-full rounded-lg border border-line bg-card px-3 py-2 text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/30';

export const consumerFilterInputMonoClass = `${consumerFilterInputClass} font-mono`;
